__turbopack_context__.v({
  "chart": "QiOpWq_chart",
  "chart-wrapper": "QiOpWq_chart-wrapper",
  "comparison": "QiOpWq_comparison",
  "comparison-charts": "QiOpWq_comparison-charts",
  "comparison-description": "QiOpWq_comparison-description",
  "comparison-title": "QiOpWq_comparison-title",
  "indicator": "QiOpWq_indicator",
  "invoice-description": "QiOpWq_invoice-description",
  "legend": "QiOpWq_legend",
});
